import React, { useContext, useEffect } from "react"
import { Badge, Button, Tooltip } from "antd"
import { MessageCircle } from "react-feather"
import { useQuery } from "@tanstack/react-query"
import { useHistory, useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { GET_CONVERSATIONS } from "../../pages/chat/queries"
import { SocketContext } from "../../contexts/SocketContext"
import { AuthContext } from "../../contexts/auth/AuthContext"
import hasPermission from "../../utils/hasPermission"

// ============================================================================
// YAGONA CHAT — sarlavhadagi tugma (egasi 2026-09-02, Q4: «chatni menyudan olib tashlab yuqorida
// ideal qilib joylashtir»). O'qilmaganlar soni = barcha suhbatlar unread yig'indisi; socket «chat»
// kelganda yangilanadi; bosilsa /chat sahifasi.
// ============================================================================
export default function ChatBell() {
  const { t } = useTranslation()
  const history = useHistory()
  const location = useLocation()
  const { authState } = useContext(AuthContext)
  const { lastMessage } = useContext(SocketContext) || {}
  const allowed = !!authState?.user && hasPermission(authState?.user, "/chat")

  const { data, refetch } = useQuery(["GET_CONVERSATIONS_BELL"], () => GET_CONVERSATIONS(), {
    enabled: allowed,
    refetchInterval: 60000,   // PERF-04
    staleTime: 10000,
  })

  useEffect(() => {
    if (lastMessage?.nameFunction === "chat") refetch()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lastMessage])

  if (!allowed) return null
  const unread = ((data?.data || []) as any[]).reduce((s: number, c: any) => s + (Number(c?.unread) || 0), 0)
  const active = location.pathname.startsWith("/chat")

  return (
    <Tooltip placement="bottom" title={t("chat")}>
      <Badge count={unread} size="small" className="hdr-badge" overflowCount={99}>
        <Button
          size="large"
          className={`buttonHeader_r headermargin_r chat-bell-btn ${active ? "active" : ""}`}
          icon={<MessageCircle size={20} strokeWidth={2} />}
          onClick={() => history.push("/chat")}
        />
      </Badge>
    </Tooltip>
  )
}
